import { WarningOutlined } from "@ant-design/icons";
import { Input as AntdInput, Row, Select } from "antd";
import cx from "classnames";
import { useField } from "formik";
import { useEffect, useMemo } from "react";

import useOptions from "features/masterData/hooks/useOptions";
import { isDigit } from "utils/validators";

import styles from "./PhoneNumber.module.css";
import { useTranslation } from "react-i18next";

const PhoneNumber = ({
  label = "",
  name = "",
  placeholder = "",
  type = "text",
  size = "middle",
  onChange = () => { },
  className = "",
  required = false,
  disabled = false,
}) => {
  const { i18n } = useTranslation();

  const { mobileCodes = [], getMobile } = useOptions();

  const [mobileNumberField, mobileNumberMeta, mobileNumberHelpers] = useField(
    `${name}.mobileNumber`
  );
  const [, mobileCodeIdMeta, mobileCodeIdHelpers] = useField(
    `${name}.mobileCodeId`
  );

  const handleMobileCodeIdChange = (selectedValue) => {
    if (selectedValue) {
      mobileCodeIdHelpers.setValue(selectedValue.value);
    }
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (isDigit(value)) {
      mobileNumberHelpers.setValue(value);
      onChange(value);
    }
  };

  const modifiedMobileCodes = useMemo(() => {
    return mobileCodes.map((mobile, idx) => ({
      ...mobile,
      key: mobile.code,
      label: (
        <Row justify="start" align="middle" key={mobile.code} style={{ gap: 8 }}>
          <img
            src={"data:image/png;base64, " + mobile.imageData}
            alt={mobile.label}
            aria-label={mobile.label}
            width={20}
            height={20}
          />
          <span>{mobile.code}</span>
        </Row>
      ),
    }));
  }, [mobileCodes]);

  const translatedError =
    mobileNumberMeta.touched && mobileNumberMeta.error ?
      i18n.language == "th" ? `กรุณากรอก ${label}` : `Please enter your ${label.toLowerCase()}` : "";

  useEffect(() => {
    if (mobileCodes.length === 0) {
      getMobile((data) => {
        // console.log("data", data.find(o=>o.code=='+66').id);
        // const firstCode = data[0] || {};
        // 
        // if (firstCode.id) {
        mobileCodeIdHelpers.setValue(data?.find(o => o.code === '+66')?.id);
        // }
      });
    }
  }, [mobileCodes, getMobile, mobileCodeIdHelpers]);

  return (
    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      <div className={styles.inputContainer}>
        <Select
          allowClear={false}
          className={styles.select}
          size={size}
          virtual={false}
          value={mobileCodeIdMeta.value}
          // defaultValue={"65a9699710afb73c9d1bf639"}
          status={
            mobileNumberMeta.touched && mobileNumberMeta.error ? "error" : ""
          }
          onChange={handleMobileCodeIdChange}
          filterOption={(input, option) => {
            return (option?.code ?? "")
              .toLowerCase()
              .includes(input.toLowerCase());
          }}
          options={modifiedMobileCodes}
          labelInValue
        />
        <AntdInput
          id={name}
          className={styles.input}
          name={name}
          placeholder={placeholder}
          type={type}
          value={mobileNumberMeta.value || ""}
          onChange={handleMobileNumberChange}
          onBlur={(e) => {
            mobileNumberField.onBlur(e);
            mobileNumberHelpers.setTouched(true);
          }}
          data-state={
            mobileNumberMeta.touched && mobileNumberMeta.error ? "error" : ""
          }
          status={
            mobileNumberMeta.touched && mobileNumberMeta.error ? "error" : ""
          }
          disabled={disabled}
          data-type={type}
          size={size}
          maxLength={12}
        />
      </div>

      {translatedError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {translatedError}
        </span>
      )}
    </div>
  );
};

export default PhoneNumber;
